"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureProdLinks = void 0;
/**
 * This utility function makes sure any dev links '.alpha.pnk.one' gets replaced
 * with prod '.alpha.storyverse.xyz'
 */
const DEV_REGEX = /.pnk.one/g;
const BETA_REGEX = /.beta/g;
const PROD_SUFFIX = '.storyverse.xyz';
const ensureProdLinks = (story) => {
    return JSON.parse(JSON.stringify(story).replace(DEV_REGEX, PROD_SUFFIX).replace(BETA_REGEX, ''));
};
exports.ensureProdLinks = ensureProdLinks;
//# sourceMappingURL=ensureProdLinks.js.map